module.exports = __webpack_public_path__ + "static/assets/f65cd88bc1b65a135f150a972bc5c3bc.png";